<template>
  <div>
    <el-table :data="records">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="amount" label="数量"></el-table-column>
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column
        prop="nextInterestAmount"
        label="预计下次收益"
      ></el-table-column>
      <el-table-column label="年化率">
        <template slot-scope="scope">
          <span>{{ Number(scope.row.yearRate * 10000) / 100 }}%</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'lockrecod',
  computed: {
    ...mapState('lockrecod', ['totalCount', 'pagination', 'rata', 'records'])
  },
  components: {
    Pagination
  },
  methods: {
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped></style>
